import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    typo:{
        marginLeft : "10vw",
        marginRight : "10vw",
    }
})


export default useStyles;